import React from 'react';
import Particle from './../../Particle';
import {Paragraph, Image, Title} from './../../Basics';

const Particle01 = () => (<div>

  <Title level={3}>
    Was für Behinderte möglich wird, wenn Mensch und Maschine verschmelzen, zeigte der weltweit erste Cybathlon-Wettkampf.
  </Title>
  <Paragraph>
  <i>Von Claudia Hoffmann und Michael Baumann.</i>                       
  </Paragraph>
                          
  <Paragraph>
   Aus dem Augenwinkel sieht Florian Hauser, dass seine Konkurrentin
   in wenigen Sekunden die Ziellinie überqueren wird. Doch er denkt nicht
   an Aufgeben. Konzentriert fährt er seinen Rollstuhl dicht an die Kante
   der obersten Treppenstufe heran – und gibt Gas.
  </Paragraph>

  <Image
    source={require('./01_FlorianHauser_Action.jpg')}
    title='Florian Hauser während des Wettkampfs'
    caption='Florian Hauser während des Rollstuhl-Rennens am ersten Cybathlon-Wettkampf. Foto: ETHZ'
  />

  <Paragraph>
    Florian ist einer von 70 Athleten aus 25 Ländern, die im vergangenen Oktober
    an einem einzigartigen Wettkampf teilgenommen haben: dem Cybathlon. Dabei traten
    körperbehinderte Teilnehmer mit robotischen Hilfsmitteln in verschiedenen Disziplinen
    gegeneinander an – angefeuert von 4000 Besuchern in der Swiss Arena in Kloten und
    unter den Augen von Zehntausenden von Fernsehzuschauern. «Von so vielen Menschen
    bejubelt zu werden ist ein Erlebnis, das ich jedem einmal wünsche», sagt Florian.
  </Paragraph>

  <Particle
    number={3}
  />

  <Image
    source={require('./01_Impression.jpg')}
    title='Impression Cybathlon'
    caption='Tausende von Zuschauern fieberten am weltweit ersten Cybathlon in Zürich mit den Athleten mit. Foto: ETHZ'
  />

  <Paragraph>
    Der querschnittsgelähmte Florian nahm am Rennen mit motorisierten Rollstühlen für
    das Team HSR Enhanced der Hochschule Rapperswil teil.
    Das Team von Ingenieuren baute eigens für den Wettkampf einen Rollstuhl, der unter
    anderem auch Treppen steigen kann – eines der schwierigsten Hindernisse im Rennen,
    für das Florian monatelang trainiert hat. Auch in den anderen Disziplinen standen
    Teilnehmer und Technologien vor schwierigen Aufgaben.
  </Paragraph>

  <Particle
    number={2}
  />

  <Particle
    number={5}
  />

 <Title level={3}>
   Höchstleistung in Alltagsaufgaben
 </Title>


 <Paragraph>
    Dabei ging es am Cybathlon nicht darum, sportliche Höchstleistungen zu bringen,
    sondern scheinbar ganz einfache Aufgaben zu bewältigen: Von einem Sessel aufstehen,
    eine Jacke zuknöpfen oder eine Dose öffnen. Für Menschen, die ihre Beine nicht bewegen
    können oder denen ein Arm fehlt, sind das Dinge, die selbst mit modernen Hilfsmitteln
    und Prothesen kaum möglich sind. «Mit dem Cybathlon wollen wir die Entwicklung neuer
    Technologien ankurbeln», sagt Robert Riener, ETH-Professor und Initiator des Wettkampfs.
  </Paragraph>

  <Particle
    number={11}
  />

  <Title level={3}>
    Knapper Sieg
  </Title>

  <Paragraph>
    Als Florian mit dem Rollstuhl die Treppenstufen hinunterholpert und er im nächsten Moment
    über die Ziellinie fährt, sind die Kameras nicht auf ihn gerichtet. Doch er hat gesiegt,
    ganz knapp vor seiner Konkurrentin aus Hongkong! Er reisst die Arme hoch, jubelt. Ob er auch
    beim nächsten Cybathlon mitmacht, der voraussichtlich in zwei Jahren stattfinden wird?
    «Wenn mich mein Team noch mal will, auf alle Fälle.»
  </Paragraph>

  <Particle
    number={23}
  />


</div>);

export default Particle01;



/** WEBPACK FOOTER **
 ** ./src/Particles/Particle01/Particle01.js
 **/